export default {"id":"385a2d1b","attrs":{"viewBox":"0 0 24 24","width":"24","height":"24"}}